import { memo, useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import {
  getStripeRecurringCheckoutUrl,
  getSubscriptionDetails,
} from '../../api/subscription';
import { OidcUser } from '../../types/oidcUser';
import { Plan } from '../../types/subscription';
import { getOrganizationId } from '../../utils/getOrganization';

const PricingCheckoutPage: React.FC = memo(() => {
  const [searchParams] = useSearchParams();
  const priceId = searchParams.get('priceId');
  const purchasedPackName = searchParams.get('purchasedPackName');

  const { user } = useAuth();
  const orgId = getOrganizationId(user as OidcUser);

  const handleCheckout = async (
    price_id: Plan['priceId'],
    returnURL: string,
  ) => {
    try {
      const subscriptionDetails = await getSubscriptionDetails({
        organization_id: orgId,
      });

      const paymentType = subscriptionDetails?.billingDetails?.paymentType;
      if (paymentType === 'Free') {
        getStripeRecurringCheckoutUrl(price_id, returnURL)
          .then((response) => {
            window.location.href = response.data.url;
          })
          .catch((error: Record<string, string>) => {
            toast.error(error.error);
          });
        return;
      }
      window.location.href = returnURL;
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (user && priceId) {
      void handleCheckout(
        priceId,
        `${window.location.origin}/pricing${
          purchasedPackName ? `?purchasedPackName=${purchasedPackName}` : ''
        }`,
      );
    }
  }, [user, priceId]);

  return null;
});

export { PricingCheckoutPage };
